import { PagePrompt, Typography } from '@weareopenr/component-library';
import styles from './ErrorBoundary.module.scss';
import { useHistory } from 'react-router-dom';
import { PostHogErrorBoundary } from '@posthog/react';

const ErrorPage = () => {
  const history = useHistory();
  return (
    <PagePrompt
      title="Oops"
      primaryButton={{
        text: 'Go to dashboard',
        onClick: () => history.push('/'),
      }}
    >
      <div className={styles['message-container']}>
        <Typography size="M" weight="bold">
          Something didn&apos;t go as planned.
        </Typography>
        <Typography size="M">
          Try again in a moment. If this keeps happening, please contact our support team.
        </Typography>
      </div>
    </PagePrompt>
  );
};
export const ErrorBoundary = ({ children }: { children: JSX.Element }) => {
  return <PostHogErrorBoundary fallback={<ErrorPage />}>{children}</PostHogErrorBoundary>;
};
